/**
 * Fit value between min and max
 */
export const limitValue = (value, min, max) => {
  if (value < min) return min;
  if (value > max) return max;
  return value;
};

/**
 * given valueFrom, valueTo, min, max, return correct value, fitting borders
 */
export const getCorrectedValues = ({ valueFrom, valueTo, min, max }, { skipLimit } = {}) => {
  /** interchange valueFrom and valueTo */
  if ((valueFrom || min) > (valueTo || max)) {
    [valueFrom, valueTo] = [valueTo, valueFrom];
  }

  if (!skipLimit) {
    /** limit values to fit [min, max] interval */
    valueFrom = valueFrom ? limitValue(valueFrom, min, max) : null;
    valueTo = valueTo ? limitValue(valueTo, min, max) : null;
  }

  return {
    valueFrom,
    valueTo: valueTo || null,
  };
};
